export default __webpack_public_path__ + "static/media/IconDesc_NuclearFuelRod.256.0243fd80.png";